import React, { useEffect, useState } from "react";
import { useReportTimer } from "./ReportDetailProvider";
import { ReportDetailTypes } from "./utils";
import { classNames } from "../utils";

type TIMER_CONFIG_TYPE = { [key: number]: string };

const TIMER_CONFIG: { [key in ReportDetailTypes]?: TIMER_CONFIG_TYPE } = {
  PROFILE_CONFIRM: { 20: "yellow", 30: "red" },
  SYSTEM: { 20: "yellow", 30: "red" },
  MANUAL_RATE: { 5: "yellow", 10: "red" },
  WEB_CONTENT: { 30: "yellow", 60: "red" },
  SCRAPE: { 5: "yellow", 10: "red" },
};

function getColorFromConfigBySeconds(
  config: TIMER_CONFIG_TYPE,
  seconds: number
): string {
  const keys = Object.keys(config);
  let color = "green";
  for (let key of keys) {
    if (seconds > +key) {
      color = config[+key];
    }
  }
  return color;
}

function ReportTimer({
  reportDetailType,
}: {
  reportDetailType: ReportDetailTypes;
}) {
  const { seconds, minutes, startTimer } = useReportTimer();
  const [currentColor, setCurrentColor] = useState("green");
  const config = TIMER_CONFIG[reportDetailType];
  useEffect(() => {
    if (!config) return;
    startTimer?.();
  }, [config, reportDetailType, startTimer]);

  useEffect(() => {
    if (!seconds || !config) return;
    const totalSeconds = seconds + (minutes ?? 0) * 60;
    const newColor = getColorFromConfigBySeconds(config, totalSeconds);
    setCurrentColor(newColor);
  }, [seconds, minutes, reportDetailType, config]);

  if (!config) return <></>;

  return (
    <div
      className={classNames(
        "fixed bottom-0 left-0 flex w-full justify-center pointer-events-none"
      )}
    >
      <div
        className={classNames(
          "flex w-24 justify-center rounded-t-lg",
          `bg-${currentColor}-300`,
          `text-${currentColor}-600`
        )}
      >
        {minutes && minutes > 0 ? (
          <>
            <span className="pr-2">{minutes}m</span>
            <span>{seconds?.toString().padStart(2, "0")}s</span>
          </>
        ) : (
          <span>{seconds}s</span>
        )}
      </div>
    </div>
  );
}
export default ReportTimer;
